import { api } from './api';

export interface NarrativeMover {
  accountCode: string;
  budget: number;
  actual: number;
  delta: number;
  deltaPct: number | null;
  factIds: string[];
}

export interface VarianceNarrativeResult {
  narrative: string;
  movers: NarrativeMover[];
  citedFactIds: string[];
  costUsd: number;
}

export interface NarrateInput {
  periodStart: string;
  periodEnd: string;
  budgetScenario?: string;
  actualScenario?: string;
  topN?: number;
}

export const varianceNarrativeApi = {
  narrate: (wsId: string, input: NarrateInput): Promise<VarianceNarrativeResult> =>
    api.post(`/api/workspaces/${wsId}/variance-narrative`, input).then((r) => r.data),
};
